import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';

const AuthContext = createContext(null);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth deve essere usato dentro AuthProvider');
  }
  return context;
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [tenant, setTenant] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Verifica token salvato
    const token = localStorage.getItem('token');
    const savedUser = localStorage.getItem('user');
    const savedTenant = localStorage.getItem('tenant');
    
    if (token && savedUser) {
      try {
        setUser(JSON.parse(savedUser));
        if (savedTenant) {
          setTenant(JSON.parse(savedTenant));
        }
        api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      } catch (e) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('tenant');
      }
    }
    setLoading(false);
  }, []);

  const login = async (username, password, tenantSlug = null) => {
    try {
      console.log('🔐 Tentativo login:', { username, tenantSlug, password: '***' });
      console.log('📡 API baseURL:', api.defaults.baseURL);
      
      const payload = { username, password };
      if (tenantSlug) {
        payload.tenantSlug = tenantSlug;
      }
      
      const response = await api.post('/auth/login', payload);
      console.log('✅ Risposta login:', response.data);
      
      const { token, user: userData, tenant: tenantData } = response.data.data;
      
      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(userData));
      if (tenantData) {
        localStorage.setItem('tenant', JSON.stringify(tenantData));
        setTenant(tenantData);
      }
      api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      
      setUser(userData);
      return { success: true };
    } catch (error) {
      console.error('❌ Errore login:', error);
      console.error('❌ Response:', error.response);
      console.error('❌ Response data:', error.response?.data);
      return { 
        success: false, 
        error: error.response?.data?.message || error.message || 'Errore di login' 
      };
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    localStorage.removeItem('tenant');
    delete api.defaults.headers.common['Authorization'];
    setUser(null);
    setTenant(null);
  };

  // Funzione per ottenere la lista dei tenant (per selezione al login)
  const getTenants = async () => {
    try {
      const response = await api.get('/auth/tenants');
      return response.data.data || [];
    } catch (error) {
      console.error('Errore caricamento tenants:', error);
      return [];
    }
  };

  const value = {
    user,
    tenant,
    loading,
    isAuthenticated: !!user,
    login,
    logout,
    getTenants,
    // Helper per visualizzare il nome dell'azienda
    tenantName: tenant?.name || tenant?.ragione_sociale || '',
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};
